import { PlusOutlined } from '@ant-design/icons';
import { useState, useEffect } from "react";
import { Row, Col, Button, Upload, Input, Breadcrumb, Form, message } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useDispatch } from 'react-redux';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { authUserData } from './../../utils/Helper';
import { Link, useNavigate } from "react-router-dom";
import { updateUser } from '../../slices/user';
import {ReactComponent as Back} from '../../Images/Back.svg';
const EditProfile = () => {
  const [form] = Form.useForm();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [imageUrl] = useState(authUserData()?.profile_image);
  const id = authUserData()?.user_id;
  const role = authUserData()?.role[0].name;
  const [formData] = useState({
    username: authUserData()?.username || "",
    first_name: authUserData()?.first_name || "",
    last_name: authUserData()?.last_name || "",
    email: authUserData()?.email || "",
    phone: authUserData()?.phone || "",
    groups: role === "Super Admin" ? ["Super Admin"] : "",
  });


  useEffect(() => {
    const fetchUser = async () => {
      try {
        form.setFieldsValue({
          username: authUserData()?.username || "",
          first_name: authUserData()?.first_name || "",
          last_name: authUserData()?.last_name || "",
          email: authUserData()?.email || "",
          phone: authUserData()?.phone || "",
        });
        setFileList(authUserData()?.profile_image ? [{ name: authUserData()?.profile_image, url: `${authUserData()?.profile_image}` }] : []);

      } catch (error) {
        console.error("");
      }
    };

    fetchUser();
  }, [id, form]);

    const handleFileChange = ({ fileList: newFileList }) => {
        setFileList(newFileList);
    };

  const toggleEdit = () => {
    setIsEditing((prev) => !prev);
  };

  const handleFinish = (values) => {
    setIsEditing(false);
    setBtnLoading(true);
    let profilePic = fileList[0]?.originFileObj || (fileList[0]?.url ? imageUrl : null);
    dispatch(updateUser({ id: id, values, profilePic }))
        .unwrap()
        .then((result) => {
            setBtnLoading(false);
            if (result.success) {
                const localStorageKey = "user"; // Replace this with the actual key if different
                const userData = JSON.parse(localStorage.getItem(localStorageKey) || "{}");
                const updatedUserData = {
                    ...userData,
                    username: result.data.username,
                    first_name: result.data.first_name,
                    last_name: result.data.last_name,
                    profile_image: result.data.profile_image,
                    phone: result.data.phone
                };
                localStorage.setItem(localStorageKey, JSON.stringify(updatedUserData));
                const refreshEvent = new Event("refreshUser");
                window.dispatchEvent(refreshEvent);
                message.success('Profile Updated Successfully!');
                navigate('/dashboard');
            }
        })
        .catch((error) => {
            setBtnLoading(false);
            message.error("User Update Failed:", error);
        });
  };

  return (
    <>
  <div className="sticyaction">
        <div className="sticky-header">
          <Row
            className="pagenamerow mb-0"
            justify="space-between"
            align="middle"
          >
            <Col>
              <h2 style={{margin: 0}}>My Profile</h2>
              <div className="bredcrumbwrp">
                <Link to="/planning-list" className="back">
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    {title: <Link to="/dashboard">Home</Link>},
                    { title: 'My Profile' }
                  ]}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <div className="formwrapper">
      <section className="grid-sec FormSection myprofile marginbottom">
        <div className="FormBody">
          <Form layout="vertical" form={form} onFinish={handleFinish} autoComplete="off">
            <Row gutter={16} className="prflrow">
              <Col xs={24} flex="auto" className="profileimg">

                    <Form.Item label="Profile Image" name="profile_image"  style={{margin: "0"}}>
                      <Upload
                          beforeUpload={() => false} // Prevent automatic upload
                          listType="picture-card"
                          accept=".jpeg,.jpg,.png"
                          maxCount={1} // Limit to 1 file
                          onChange={handleFileChange} // Update the state
                          fileList={fileList} // Bind fileList state
                          showUploadList={{ showRemoveIcon: isEditing }}
                      >
                          {fileList.length < 1 && ( // Show placeholder only if no files uploaded
                              <div>
                                <PlusOutlined />
                                <div
                                    style={{
                                        marginTop: 8,
                                    }}
                                >
                                  Upload
                                </div>
                              </div>
                          )}
                      </Upload>
                    </Form.Item>

              </Col>
              <Col flex="auto" className="prflcont">
                <Row gutter={[15]}>
                  {isEditing ? (
                    <>
                    <Col xs={24} sm={24} md={12} lg={12}>
                    <Form.Item
                        label="Username"
                        name="username"
                        rules={[
                            { required: true, message: 'Please enter username' },
                            {
                                pattern: /^[A-Za-z0-9@.+\-_]+$/,
                                message: 'Only letters, digits, and @/./+/-/_ are allowed',
                            },
                        ]}
                    >
                        <Input placeholder="Enter User Name" onChange={(e) => {
                            const value = e.target.value;
                            const formattedValue = value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
                            form.setFieldsValue({ username: formattedValue }); // Update Form state
                        }} />
                    </Form.Item>
                    </Col>
                      <Col xs={24} sm={24} md={12} lg={12}>
                        <Form.Item
                          label="First Name"
                          name="first_name"
                          rules={[
                            { required: true, message: 'Please enter first name' },
                            {
                              pattern: /^[A-Za-z]+$/,
                              message: 'Only alphabets are allowed',
                            }
                          ]}
                        >
                          <Input placeholder="Enter First Name" onChange={(e) => {
                            const value = e.target.value;
                            const formattedValue = value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
                            form.setFieldsValue({ first_name: formattedValue }); // Update Form state
                          }} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12}>
                        <Form.Item
                          label="Last Name"
                          name="last_name"
                          rules={[
                            { required: true, message: 'Please enter last name' },
                            {
                              pattern: /^[A-Za-z]+$/,
                              message: 'Only alphabets are allowed',
                            }
                          ]}
                        >
                          <Input placeholder="Enter Last Name" onChange={(e) => {
                            const value = e.target.value;
                            const formattedValue = value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
                            form.setFieldsValue({ last_name: formattedValue }); // Update Form state
                          }} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12}>
                        <Form.Item
                          label="Email Address"
                          name="email"
                          rules={[{ required: true, message: 'Please enter email' }]}
                        >
                          <Input placeholder="Enter Last Name" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12}>
                        <Form.Item
                          label="Phone Number"
                          name="phone"
                          rules={[
                            {
                              required: true,
                              message: 'Please enter your phone number!',
                            },
                          ]}
                        >
                          <PhoneInput
                            country={'in'} // Default country (India)
                            enableSearch={true} // Enable searching for countries
                            placeholder="Enter phone number"
                          />
                        </Form.Item>
                      </Col>
                    </>
                  ) : (
                    <>
                      <Col xs={24} sm={24} md={12} lg={12}>
                        <Form.Item>
                          <label>First Name</label>
                          <p>{formData.first_name}</p>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12}>
                        <Form.Item>
                          <label>Last Name</label>
                          <p>{formData.last_name}</p>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12}>
                        <Form.Item>
                          <label>Email</label>
                          <p>{formData.email}</p>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12}>
                        <Form.Item>
                          <label>Phone</label>
                          <p>+{formData.phone}</p>
                        </Form.Item>
                      </Col>
                    </>
                  )}
                </Row>
              </Col>
            </Row>
            <Row justify="end" gutter={16}>
              <Col>
                {isEditing ? (
                  <>
                    <Button type="secondary" onClick={toggleEdit} style={{ marginRight: "16px" }}>
                      Cancel
                    </Button>
                    <Button type="primary" htmlType="submit" loading={btnLoading}>
                      Save
                    </Button>

                  </>
                ) : (
                  <Button type="primary" icon={<EditOutlined />} onClick={toggleEdit}>
                    Edit Profile
                  </Button>
                )}
              </Col>
            </Row>
          </Form>
        </div>
      </section>
      </div>
    </>
  );
};

export default EditProfile;
